<template>
  <q-page padding>
    <PageHeader
      title="Upload de Arquivos"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="crie" label="CRIE PRODUTOS POR PLANILHA" />
      <q-tab name="atualize" label="ATUALIZE PRODUTOS POR PLANILHA" />
      <q-tab name="remova" label="REMOVA ITENS DO CATÁLOGO" />
      <q-tab name="zerar" label="ZERAR PONTOS DE REPOSIÇÃO DOS ITENS" />
      <q-tab name="desativar" label="DESATIVAR CONTROLE DE LOTE" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <!-- ===== CRIE PRODUTOS ===== -->
      <q-tab-panel name="crie">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIE PRODUTOS POR PLANILHA
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosCrie"
          :showUnidade="false"
          :activeSlide="activeSlide"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de criação de produtos</h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file1, 'drag-over': isDragOver1 }"
              @dragover.prevent="isDragOver1 = true"
              @dragleave.prevent="isDragOver1 = false"
              @drop.prevent="onDrop(1, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file1">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file1.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file1 ? 'positive' : 'primary'"
                      :icon="file1 ? 'check_circle' : 'folder_open'"
                      :label="
                        file1 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput1.click()"
                    />
                    <input
                      ref="fileInput1"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(1, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file1">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file1.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file1.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file1"
                @click="enviar(1, 'produto')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== ATUALIZE PRODUTOS ===== -->
      <q-tab-panel name="atualize">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ATUALIZE PRODUTOS POR PLANILHA
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide2 = !activeSlide2"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosAtualize"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de atualização de produtos
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file2, 'drag-over': isDragOver2 }"
              @dragover.prevent="isDragOver2 = true"
              @dragleave.prevent="isDragOver2 = false"
              @drop.prevent="onDrop(2, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file2">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file2.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file2 ? 'positive' : 'primary'"
                      :icon="file2 ? 'check_circle' : 'folder_open'"
                      :label="
                        file2 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput2.click()"
                    />
                    <input
                      ref="fileInput2"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(2, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file2">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file2.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file2.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file2"
                @click="enviar(2, mapeamentoAtualizacao)"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== REMOVA ITENS ===== -->
      <q-tab-panel name="remova">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            REMOVA ITENS DO CATÁLOGO
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide3 = !activeSlide3"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosRemova"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_remover_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide3"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de remoção de itens</h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file3, 'drag-over': isDragOver3 }"
              @dragover.prevent="isDragOver3 = true"
              @dragleave.prevent="isDragOver3 = false"
              @drop.prevent="onDrop(3, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file3">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file3.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file3 ? 'positive' : 'primary'"
                      :icon="file3 ? 'check_circle' : 'folder_open'"
                      :label="
                        file3 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput3.click()"
                    />
                    <input
                      ref="fileInput3"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(3, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file3">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file3.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file3.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file3"
                @click="enviar(3, 'delete_produto')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== ZERAR PONTOS ===== -->
      <q-tab-panel name="zerar">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ZERAR PONTOS DE REPOSIÇÃO DOS ITENS
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide4 = !activeSlide4"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosZerar"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide4"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha para zerar pontos de reposição
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file4, 'drag-over': isDragOver4 }"
              @dragover.prevent="isDragOver4 = true"
              @dragleave.prevent="isDragOver4 = false"
              @drop.prevent="onDrop(4, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file4">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file4.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file4 ? 'positive' : 'primary'"
                      :icon="file4 ? 'check_circle' : 'folder_open'"
                      :label="
                        file4 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput4.click()"
                    />
                    <input
                      ref="fileInput4"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(4, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file4">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file4.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file4.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file4"
                @click="enviar(4, 'zerar_limites_produto')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== DESATIVAR LOTE ===== -->
      <q-tab-panel name="desativar">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            DESATIVAR CONTROLE DE LOTE
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide5 = !activeSlide5"
            />
          </p>
        </div>
        <infot-upload
          :infos="infosDesativar"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide5"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha para desativar controle de lote
            </h6>
          </div>
          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file5, 'drag-over': isDragOver5 }"
              @dragover.prevent="isDragOver5 = true"
              @dragleave.prevent="isDragOver5 = false"
              @drop.prevent="onDrop(5, $event)"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file5">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />{{
                      file5.name
                    }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file5 ? 'positive' : 'primary'"
                      :icon="file5 ? 'check_circle' : 'folder_open'"
                      :label="
                        file5 ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput5.click()"
                    />
                    <input
                      ref="fileInput5"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="(e) => onFileSelected(5, e)"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file5">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info"
                    >Tamanho: {{ formatFileSize(file5.size) }}</q-chip
                  >
                  <q-chip color="positive" text-color="white" icon="event"
                    >Tipo: {{ file5.type || "Excel" }}</q-chip
                  >
                </div>
              </div>
            </div>
            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!file5"
                @click="enviar(5, 'desativacao_lote')"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import InfotUpload from "../../compras/components/InfotUpload.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { InfotUpload, ListaUnidadesSelect, PageHeader },

  setup() {
    const store = useStore();
    const $q = useQuasar();

    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);
    const activeSlide5 = ref(false);

    const file1 = ref(null);
    const file2 = ref(null);
    const file3 = ref(null);
    const file4 = ref(null);
    const file5 = ref(null);

    const fileInput1 = ref(null);
    const fileInput2 = ref(null);
    const fileInput3 = ref(null);
    const fileInput4 = ref(null);
    const fileInput5 = ref(null);

    const isDragOver1 = ref(false);
    const isDragOver2 = ref(false);
    const isDragOver3 = ref(false);
    const isDragOver4 = ref(false);
    const isDragOver5 = ref(false);

    const files = { 1: file1, 2: file2, 3: file3, 4: file4, 5: file5 };

    const mapeamentoAtualizacao = computed(() => {
      const cliente = store.state.autenticacao.cliente || "";
      const isAcciona =
        cliente.includes("acciona") || cliente.includes("staging-acciona");
      return isAcciona ? "produto_edicao_acciona" : "produto";
    });

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (tab, e) => {
      if (e.target.files[0]) files[tab].value = e.target.files[0];
    };

    const onDrop = (tab, e) => {
      const dragRefs = {
        1: isDragOver1,
        2: isDragOver2,
        3: isDragOver3,
        4: isDragOver4,
        5: isDragOver5,
      };
      dragRefs[tab].value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        files[tab].value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviarParaN8n = async (planilhaBase64, mapeamento) => {
      const n8nEndpoint =
        "https://n8n.devops.multpex.com.br/webhook/356d6cf5-5d36-4a04-8759-0eb4b8f150c6";
      const payload = {
        planilha: planilhaBase64,
        mapeamento,
        unidade: store.state.org.unidadeData.nome,
        tenant: store.state.autenticacao.cliente[0],
        timestamp: new Date().toISOString(),
        origem: "catalogo-upload",
      };
      const response = await fetch(n8nEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(
          `Erro HTTP: ${response.status} - ${response.statusText}`
        );
      }
      return await response.json();
    };

    const enviar = async (tab, mapeamento) => {
      const fileRef = files[tab];
      if (!fileRef.value || !fileRef.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileRef.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        const response = await store.dispatch("catalogo/uploads", {
          planilha: result,
          mapeamento,
          unidade: store.state.org.unidadeData.id,
        });

        $q.loading.hide();
        $q.notify({
          message:
            response.data?.result ||
            response.data?.message ||
            "Template enviado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        try {
          await enviarParaN8n(result, mapeamento);
        } catch (n8nError) {
          console.error("Erro ao enviar para n8n:", n8nError);
          $q.notify({
            message: "Template enviado, mas falha no processamento secundário",
            color: "warning",
            actions: [{ label: "Fechar", color: "white", handler: () => {} }],
          });
        }

        fileRef.value = null;
      } catch (error) {
        $q.loading.hide();
        const errorMessage =
          error.response?.data?.result?.error ||
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.response?.data?.result ||
          "Erro ao enviar template";
        $q.notify({
          message: errorMessage,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const infosCrie = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Os dados da coluna A e B, código e descrição são obrigatórios",
        icon: "star",
      },
      {
        name: "Caso a informação de Categoria e Grupo de Produto tiver erro de digitação, o sistema criará uma nova categoria e grupo",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosAtualize = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Os dados da coluna A e B, código e descrição são obrigatórios",
        icon: "star",
      },
      {
        name: "Caso a informação de Categoria e Grupo de Produto tiver erro de digitação, o sistema criará uma nova categoria e grupo",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosRemova = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "Verifique que o saldo do material está zerado para que a remoção seja bem sucedida",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosZerar = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosDesativar = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      activeSlide5,
      file1,
      file2,
      file3,
      file4,
      file5,
      fileInput1,
      fileInput2,
      fileInput3,
      fileInput4,
      fileInput5,
      isDragOver1,
      isDragOver2,
      isDragOver3,
      isDragOver4,
      isDragOver5,
      mapeamentoAtualizacao,
      formatFileSize,
      onFileSelected,
      onDrop,
      enviar,
      infosCrie,
      infosAtualize,
      infosRemova,
      infosZerar,
      infosDesativar,
      tab: ref("crie"),
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
